import AuditTrailFilterView from '@UI/Pages/Administration/AuditTrail/Filters/AuditTrailFilterView';
import { createSignal } from '@verclam/pulsar';

const auditTrailFiltersSignal = createSignal<AuditTrailFilterView>(AuditTrailFilterView.createDefault());

export const setAuditTrailFilters = (filters: AuditTrailFilterView): void => {
	auditTrailFiltersSignal.value = filters;
};

export default auditTrailFiltersSignal;
